import React, { Fragment, useEffect, useRef, useState } from "react";
import { handleGetApiGF, rupeesFn, Toast } from "../Utils/general-function";

import NoCars from "../Utils/NoCars";
import Header from "../Header";
import Loader from "../Utils/Loader";

const PAGE_SIZE = 10;

const RcSearchLog = () => {
  const [loader, setLoader] = useState(false);
  const [logs, setLogs] = useState([]); // logs data array
  const [hasMore, setHasMore] = useState(true); // to check has more data or not
  const loaderRef = useRef(null); // load more loader
  const pageRef = useRef(1);
  const initialLoadRef = useRef(false);

  const fetchLogs = async (pageNo) => {
    if (loader) return;

    try {
      setLoader(true);

      const params = new URLSearchParams({
        Pageindex: pageNo,
        time: Date.now(),
      });

      const res = await handleGetApiGF({
        url: "/api/WalletTransaction/DealerWalletTransactionlog?" + params,
      });

      if (!res?.succ) {
        Toast(false, "", res?.msg || "Failed to fetch logs");
        return;
      }

      const newLogs = res?.data?.Data || [];

      setLogs((prev) => [...prev, ...newLogs]);
      setHasMore(newLogs.length === PAGE_SIZE);
    } catch (err) {
      console.error(err);
      Toast(false, "", "Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  // Initial load
  useEffect(() => {
    if (!initialLoadRef.current) {
      initialLoadRef.current = true;
      fetchLogs(1);
    }
  }, []);

  // Infinite scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasMore && !loader && logs.length > 0) {
          pageRef.current += 1;
          fetchLogs(pageRef.current);
        }
      },
      {
        threshold: 0.1,
      },
    );

    const current = loaderRef.current;

    if (current) {
      observer.observe(current);
    }

    return () => {
      if (current) observer.unobserve(current);
      observer.disconnect();
    };
  }, [hasMore, loader, logs.length]);

  return (
    <div>
      <Header />

      {loader && logs.length === 0 && <Loader />}

      <div className="text-center">
        <h2 className="page-title">Car Info Logs</h2>
      </div>

      <div className="txn-container page-space">
        {/* <h5 className="mb-0">
          Total Searches : <b className="text-danger">{logs.length}</b>
        </h5> */}

        {logs.length > 0 ? (
          <>
            {logs.map((item) => (
              <Fragment key={item?.Id}>
                <div className="txn-card">
                  <div className="txn-icon">
                    <span className="material-symbols-outlined fw-4 text-danger">
                      directions_car
                    </span>
                  </div>

                  <div className="txn-content">
                    <div className="txn-top">
                      <div>
                        <h3 className="mb-0">
                          {String(item?.Vehicalno || "").toUpperCase()}
                        </h3>

                        <span>
                          {new Date(item?.dCreateDate)
                            .toLocaleString("en-IN")
                            .toUpperCase()
                            .replace(",", " •")}
                        </span>
                      </div>

                      <div>
                        <span className="txn-amount text-danger">
                          - {rupeesFn(item?.ServicesPrice, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Fragment>
            ))}

            {hasMore && (
              <div ref={loaderRef} className="text-center py-3">
                {loader ? "Loading..." : ""}
              </div>
            )}
          </>
        ) : (
          !loader && <NoCars img="" mainMsg="No Logs Found" msg="" />
        )}
      </div>
    </div>
  );
};

export default RcSearchLog;
// import React, { Fragment, useEffect, useRef, useState } from "react";
// import { handleGetApiGF, rupeesFn, Toast } from "../Utils/general-function";

// import NoCars from "../Utils/NoCars";
// import Header from "../Header";
// import Loader from "../Utils/Loader";

// const RcSearchLog = () => {
//   const [loader, setLoader] = useState(true);
//   const [logs, setLogs] = useState([]);
//   const [hasMore, setHasMore] = useState(true);
//   const [page, setPage] = useState(1);

//   let loaderRef = useRef(null);

//   const fetchLogs = async (pageIdx) => {
//     setLoader(true);
//     let obj = new URLSearchParams({
//       Pageindex: pageIdx,
//       time: Date.now(),
//     });
//     const res = await handleGetApiGF({
//       url: "/api/WalletTransaction/DealerWalletTransactionlog?" + obj,
//     });
//     setLoader(false);
//     setHasMore(res?.data?.Data?.length === 10);
//     setLogs((prev) => [...prev, ...(res?.data?.Data || [])]);
//     Toast(res?.succ, res?.msg, res?.msg);
//   };
//   useEffect(() => {
//     fetchLogs(page);
//   }, [page]);

//   useEffect(() => {
//     // fetchLogs();
//     let observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting && hasMore) {
//           setPage((pre) => {
//             let pageIndex = pre + 1;
//             fetchLogs(pageIndex);
//           });
//         }
//       },
//       { threshold: 0.5 },
//     );
//     if (loaderRef.current) {
//       observer.observe(loaderRef.current);
//     }
//     return () => observer.disconnect();
//   }, [hasMore]);

//   return (
//     <div>
//       <Header />
//       {loader && <Loader />}
//       <div className="text-center">
//         <h2 className="page-title">Car Info Logs</h2>
//       </div>
//       <div className="txn-container page-space">
//         <h5 className="mb-0">
//           Total Searches : <b className="text-danger">{logs?.length}</b>
//         </h5>
//         {logs.length > 0 ? (
//           <>
//             {logs.map((item) => (
//               <Fragment key={item?.Id}>
//                 <div className="txn-card">
//                   {/* LEFT ICON */}
//                   <div className="txn-icon">
//                     <span className="material-symbols-outlined fw-4 text-danger">
//                       directions_car
//                     </span>
//                   </div>

//                   <div className="txn-content">
//                     {/* TOP */}
//                     <div className="txn-top">
//                       <div>
//                         {" "}
//                         <h3 className="mb-0">
//                           {String(item?.Vehicalno).toUpperCase()}
//                         </h3>
//                         <span>
//                           {new Date(item?.dCreateDate)
//                             ?.toLocaleString("en-IN")
//                             ?.toUpperCase()
//                             ?.split(",")
//                             ?.join(" • ")}
//                         </span>
//                       </div>
//                       <div>
//                         <span className={`txn-amount text-danger`}>
//                           - {rupeesFn(item?.ServicesPrice)}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </Fragment>
//             ))}
//           </>
//         ) : (
//           <NoCars img="" mainMsg="No Logs Found" msg="" />
//         )}
//         {hasMore && <div ref={loaderRef}>Loading...</div>}
//       </div>
//     </div>
//   );
// };

// export default RcSearchLog;
